<template>
    <v-dialog  v-model="dialog" scrollable max-height="auto" :max-width="($vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm') ? '90%' : '50%'" persistent >
        <v-card 
                outlined
                height="75vh"
                prominent
                class="mx-auto elevation-0 overflow-y-auto"
            >

            <v-card-title class="ma-0 pa-0">
                <v-app-bar dense height="45" class='mb-0 elevation-1'>
                        <v-toolbar-title class="subtitle-1">
                            <span class="mb-0">
                                Extrato - ({{ selected.length }}) Professor(es) selecionado(s) <strong v-if="selected.length > maxSelected" class="red--text">Máximo {{ maxSelected }} professores</strong>
                            </span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>

                    <emc-button-icon color="primary lighten-2" icon="mdi-filter-remove-outline" text="Limpar Seleção" :disabled="selected.length === 0" @click.prevent.stop="clearFilter()" />
                    <emc-button-icon color="error darken-1" icon="mdi-file-pdf-box" text="Gerar Extratos" :disabled="disableButton" @click.prevent.stop="exportExtracts(false)" />
                    <emc-button-icon color="purple" icon="mdi-folder-zip-outline" text="Gerar Extratos Zipado" :disabled="disableButton || selected.length < 2" @click.prevent.stop="exportExtracts(true)" />
                    <emc-button-icon color="red lighten-2" icon="mdi-close" text="Fechar" @click.prevent.stop="dialog = false" />

                </v-app-bar>
            </v-card-title>
            
            <v-card-text  class="pt-2">
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-list>
                                    <v-list-item-group
                                        v-model="selectedTeacher"
                                        color="primary"
                                    >
                                            <v-list-item
                                                ripple
                                                @mousedown.prevent
                                                @click="toggle"
                                            >
                                                <v-list-item-action>
                                                    <v-icon v-if="items.length" :color="selected.length > 0 ? 'indigo darken-4' : ''">
                                                        {{ icon }}
                                                    </v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Selecionar todos
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                                </v-list-item>
                                                <v-divider></v-divider>
                                                
                                                <v-progress-linear
                                                    v-if="loading"
                                                    indeterminate
                                                    color='yellow darken-2'
                                                />

                                                <emc-util-scroll height="45vh">
                                                    <v-list-item
                                                        v-for="(item, index) in items"
                                                        :key="index"
                                                        @mousedown.prevent
                                                        @click="selectTeacher(index)"
                                                        >
                                                        <v-list-item-icon>
                                                            <v-icon :color="isCheckedTeacher(index) ? 'indigo darken-4' : ''" v-text="isCheckedTeacher(index) ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline'" />
                                                        </v-list-item-icon>
                                                        <v-list-item-content>
                                                            <v-list-item-title v-text="item.name"></v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </emc-util-scroll>
                                    </v-list-item-group>
                                </v-list>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-row>
                            <v-col cols="11">
                                <v-pagination
                                    v-model="page"
                                    class="my-4"
                                    @input="pagination()"
                                    :length="totalPages"
                                ></v-pagination>
                            </v-col>
                        </v-row>
                    </v-container>
            </v-card-actions>
            
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions } from 'vuex'
import  { myMixin } from '../../../mixins';

export default {
    mixins: [myMixin],
    name: "SysTeacherFilter",
    data: (vm) => ({
        dialog: false,
        loading: false,
        page: 1,
        maxSelected: 30,
        totalPages: 0,
        items: [],
        selected: [],
        selectedCurrent: [],
        selectedTeacher: null,
    }),
    computed: {
        
        disableButton (){
            
            return !this.selected.length || this.selected.length > this.maxSelected;

        },

        likesAllTeacher () {
            
            return this.selectedCurrent.length === this.items.length
        },

        likesSomeTeacher () {
            return this.selectedCurrent.length > 0 && !this.likesAllTeacher
        },

        icon () {
            if (this.likesAllTeacher) return 'mdi-close-box'
            if (this.likesSomeTeacher) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },

    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },

    watch: {

        dialog() {
            this.$emit('update:show', this.dialog);
        },

        show(val) {
            
            this.dialog = val;

            if(val){
                
                if(this.items.length == 0){
                    this.getItems();
                }

            }
        },

    },
    methods: {
        ...mapActions('teacher', ['ActionFindTeachers']),        
        
        async getItems() {

            this.loading = true;
            this.selectedCurrent = [];

            let payload = {
                column_order: 'name',
                direction: 'asc',
                page:       this.page,
                per_page:   this.maxSelected,
                find_columns: {
                    active: 1,
                    teacher_status_id: 1,
                },
                filter_relations: [
                    {
                        name: 'contracts',
                        key: 'teacher_contract_type_id', 
                        value: 1,
                        includeNull: true
                    }
                ]
            }

            await this.ActionFindTeachers(payload)
                    .then((res) => {
                        this.totalPages = res.meta.last_page;
                        this.items = res.data;

                        this.items.forEach(item => {
                            if(this.selected.includes(item.id)){
                                this.selectedCurrent.push(item.id);
                            }
                        });

                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        pagination(){

            this.getItems();

        },


        exportExtracts(zipFile){

            let ids = '';

            this.selected.forEach(id => {
                
                if(ids != ''){
                   ids += ',';
                }

                ids += id;

            });

            let params = zipFile ? 'zipFile=true' : null;
            
            this.exportPdf('teacher-extract', ids, null, params);

       },

       toggle () {
            
            this.$nextTick(() => {
                
                if (this.likesAllTeacher) {
                    
                    this.selectedCurrent.forEach(id => {
                        
                        if(this.selected.includes(id)){
                            this.selected.splice(this.selected.indexOf(id), 1);
                        }
                    });
                   
                    this.selectedCurrent = [];

                }else{
                    for (let index = 0; index < this.items.length; index++) {
                        
                        let id = this.items[index]['id'];
                        
                        if(!this.selected.includes(id)){
                            this.selected.push(id);
                        }

                        if(!this.selectedCurrent.includes(id)){
                            this.selectedCurrent.push(id);
                        }
                   }
                }
                
            })
        },

        clearFilter(){
            this.selected = [];
            this.selectedCurrent = [];
        },

        isCheckedTeacher(index){
            
            let id = this.items[index]['id'];
            
            return this.selected.includes(id);
        },

        selectTeacher(index){
            
            let id = this.items[index]['id'];
            
            if(this.selected.includes(id)){
                this.selected.splice(this.selected.indexOf(id), 1);
            }else{
                this.selected.push(id);
            }

            if(this.selectedCurrent.includes(id)){
                this.selectedCurrent.splice(this.selectedCurrent.indexOf(id), 1);
            }else{
                this.selectedCurrent.push(id);
            }
            
        },

        

    }
}
</script>